import React from 'react'
import {useHistory, useLocation} from 'react-router-dom'

import styles from "./ParentRouteRedirect.module.scss"

type ParentRouteRedirectProps = {
    route?: string
    children: React.ReactNode
    isCohortAnalyser?: boolean
}

const ParentRouteRedirect = ({route, children, isCohortAnalyser}: ParentRouteRedirectProps) => {

    const history = useHistory()
    const location = useLocation()

    const handleRedirect = () => {
        if (!isCohortAnalyser && location.pathname !== route) {
            history.push(route)
        }
    }

    return (
        <div onClick={handleRedirect}
             className={isCohortAnalyser ? styles.cohortAnalyserRouteTitle : styles.routeTitle}>
            {children}
        </div>
    )

}

export default ParentRouteRedirect